import React, { useState, useEffect} from 'react';
import { Route, Redirect } from 'react-router-dom';
import UseAuth from './UseAuth';


const ProtectedRoute = ({ children, roles }) => {
  const { userroles } = UseAuth();
  const {isLoading} = UseAuth(); 
 
  let hasAccess = false;

 
  if (Array.isArray(roles)) {
    for (const r of roles) {
      if (userroles && userroles.includes(r)) {
        
        hasAccess = true;
        break;
      }
    }
  } else {
   hasAccess = false;
  }
 if (!hasAccess) {
  
    return (
     <div id="main">
      <div class="left"></div>
      
      <div class="center left-center">
        {!isLoading && (
        <><h1>Unauthorized</h1><p>You do not have permission to access this page.</p></>
        )}
        </div>
        
      </div>
    );
  }

  return children;
};


export default ProtectedRoute;
